import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";


export default function DataGridTable({mentoredTeacher,appliedUniversities,appliedTimelines,appliedTerms,appliedPrograms,selectedUniversities}) {
  const navigate = useNavigate();

  const handleRowClick = (params) => {
    navigate(`/individualteacher`, { state: { teacherName: params.row.tname ,teacherid: params.row.tid ,  appliedTerms: appliedTerms, appliedTimelines: appliedTimelines,appliedUniversities: appliedUniversities , appliedPrograms: appliedPrograms,selectedUniversities:appliedUniversities} });
    // navigate(`/individualteacher`, { state: { teacherName: params.row.tname ,teacherid: params.row.tid  } });
    
  };
  const columns = [
    { field: "sno", headerName: "S.no", width: 100, headerAlign: "left", align: "left",
      sortable: false, // Prevent sorting on S.No
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1
    },
    { field: "tname", headerName: "Name", width: 200, headerAlign: "left", align: "left" },
    { field: "unitdeploy", headerName: "Unit", width: 250, headerAlign: "left", align: "left" },
    { field: "averdurationthreshold", headerName: "Active Students",flex: 2, minWidth: 150, headerAlign: "center", align: "center"  },
    { field: "midtermsurvey", headerName: "Student Satisfaction - Mid Term", flex: 2, minWidth: 300, headerAlign: "center", align: "center" },
    { field: "endtermsurvey", headerName: "Student Satisfaction - End Term", flex: 2, minWidth: 300, headerAlign: "center", align: "center" },
    // { field: "gradingcompliance", headerName: "Grading Quality Score", flex: 2, minWidth: 200, headerAlign: "center", align: "center" }
  ];
  
  // const columns = [
  //   { field: "sno", headerName: "S.no", width: 100 },
  //   { field: "tname", headerName: "Teacher Name", width: 200 },
  //   {
  //     field: "unitdeploy",
  //     headerName: "Unit",
  //     width: 200,
  //   },
    // {
    //   field: "university",
    //   headerName: "University",
    //   width: 200,
    // },
    // {
    //   field: "averdurationthreshold",
    //   headerName: " Active Students",
    //   width: 230,
    // },
    // {
    //   field: "midtermsurvey",
    //   headerName: "Student Satisfaction Score - Mid-Term",
    //   flex: 2,
    //   minWidth: 250,
    // },
    // {
    //   field: "endtermsurvey",
    //   headerName: "Student Satisfaction Score - End-Term",
    //   flex: 2,
    //   minWidth: 250,
    // },
    // {
    //   field: "gradingcompliance",
    //   headerName: " Grading Quality Score",
    //   flex: 2,
    //   minWidth: 200,
    // },
    
    // {
    //   field: "viewdetails",
    //   headerName: "View Details",
    //   width: 150,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <IconButton
    //       onClick={() => handleRowClick(params)}  // Pass params here
    //       color="primary"
    //       type="button"
    //       className="conv-view-btn"
    //     >
    //       <VisibilityIcon />
    //     </IconButton>
    //   )
    // }
  
  // ];
  
 // Dynamically generate rows from teacherQcDetails
 const rows = mentoredTeacher && mentoredTeacher.length > 0
 ? mentoredTeacher.map((teacher, index) => ({
     id: index + 1,  // Unique ID for each row
     sno: index + 1,  // Serial number
     tname: teacher.name, 
     tid:teacher.id,
     uid:teacher?.units_deployed?.unit_id,
     unit_id:teacher?.units_deployed?.unit_id,
     unitdeploy: teacher?.units_deployed?.unit_name,
    //  university: teacher.university_name,
      averdurationthreshold: teacher.total_student,
     midtermsurvey:teacher?.average_mid_satisfaction_score || "0",
     endtermsurvey:teacher?.average_end_satisfaction_score || "0",
     gradingcompliance:teacher?.assessment_grading_score || "0",
   }))
 : [];  // If teacherQcDetails is empty or null, return an empty array

  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 25]}
        pagination
        onRowClick={handleRowClick}
        autoHeight // This prop allows the grid to automatically adjust its height based on the number of rows
        sx={{
          fontFamily: "Nunito Sans, sans-serif",
          fontSize: "14px",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#ebebeb",
            color: "#000",
            fontWeight: "bold",
            fontSize: "14px",
            padding: "6px",
            fontFamily: "Nunito Sans, sans-serif",
          },
          "& .MuiDataGrid-cell": {
            padding: "6px",
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: "14px",
          },
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
            backgroundColor: "#f5f5f5",
          },
        }}
      />
    </div>
  );
}
